<template>
  <div v-if="campaignExists" class="pb-4">
    <div class="panel" :class="{ 'panel-with-footer': !isLoading }">
      <div v-if="isLoading">
        <div class="px-5 pb-5"><campaign-loading-skeleton /></div>
      </div>
      <div v-else>
        <div class="panel-body-lg">
          <div class="pb-3">
            <div class="d-flex flex-column flex-lg-row justify-content-lg-between">
              <h2>Watch now</h2>
            </div>
          </div>
          <div class="alert alert-error" v-if="isErrored">
            {{ CONSTANTS.SERVER_ERROR_MESSAGE }}
          </div>
          <div v-else>
            <div>
              <div>
                <video-card-featured 
                  :featured-video="this.featuredVideo.value[0].fields"
                  @isError="handleErrorMessage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
  import api from "@/api";
  import moment from "moment/moment";
  import * as CONSTANTS from "@/store/constants";
  import VideoCardFeatured from "./VideoCardFeatured";
  import CampaignLoadingSkeleton from "./CampaignLoadingSkeleton";
  import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
  
  export default {
    name: "campaigns-panel",
    mixins: [HomebaseMixpanelMixin],
    components: {
      VideoCardFeatured,
      CampaignLoadingSkeleton
    },
    data() {
      return {
        CONSTANTS,
        isLoading: false,
        isErrored: false,
        featuredVideo: null
      };
    },
    created() {
      this.initializeCampaignPanel();
    },
    methods: {
      async initializeCampaignPanel() {
        try {
          this.isLoading = true;
          this.featuredVideo = await this.getVideoCampaignData();
          this.isLoading = false;
        } catch (e) {
          this.handleErrorMessage();
        }
      },
      async getVideoCampaignData() {
        const currentDateTime = moment().toISOString();
        return await api.getVideoCampaigns(currentDateTime);
      },
      handleErrorMessage() {
        this.isErrored = true;
      },
    },
    computed: {
      campaignExists() {
        return this.featuredVideo && this.featuredVideo.value && this.featuredVideo.value.length > 0;
      },
    },
  };
</script>
  
<style scoped>
  .panel {
    padding-top: 25px;
    min-height: 420px;
    position: relative;
  }
  .panel-body {
    padding-left: 4rem;
    padding-right: 4rem;
  }
  .panel-with-footer {
    padding-bottom: 30px;
  }
</style>
  


// WEBPACK FOOTER //
// src/components/homebase/campaigns/CampaignsPanel.vue